import { Language } from '@yleisradio/areena-types';
import {
  LegacyLanguageCodeMap,
  MediaLanguageCode,
  SubtitleTrackKind,
} from '../appTypings';
import fi from './fi.json';
import sv from './sv.json';
import { ErrorName } from '../error/errors';
import { ErrorMessageMap } from '../error/errorMessages';

type Key = keyof typeof fi;

export function getTranslation(key: Key, language: Language): string {
  switch (language) {
    case 'fi':
      return fi[key];
    case 'sv':
      return sv[key];
    default:
      throw new Error('Unsupported language');
  }
}

type SubtitleLanguageTranslation = {
  [L in Language]: {
    [K in SubtitleTrackKind]: Partial<Record<MediaLanguageCode, string>>;
  };
};

export const subtitleLanguage: SubtitleLanguageTranslation = {
  fi: {
    hardOfHearing: {
      fin: 'Suomi (ohjelmatekstitys)',
      swe: 'Ruotsi (ohjelmatekstitys)',
      eng: 'English subtitles',
      sme: 'Saame',
    },
    translation: {
      fin: 'Suomi (käännöstekstitys)',
      swe: 'Ruotsi (käännöstekstitys)',
      eng: 'English subtitles',
      sme: 'Saame',
      ukr: 'Ukrainska',
    },
  },
  sv: {
    hardOfHearing: {
      fin: 'Finska (programtextning)',
      swe: 'Svenska (programtextning)',
      eng: 'English subtitles',
      sme: 'Saame',
      ukr: 'Ukrainska',
    },
    translation: {
      fin: 'Finska (översättning)',
      swe: 'Svenska (översättning)',
      eng: 'English subtitles',
      sme: 'Saame',
      ukr: 'Ukrainska',
    },
  },
};

type AudioLanguageTranslation = {
  [L in Language]: Record<MediaLanguageCode, string>;
};

export const audioLanguage: AudioLanguageTranslation = {
  fi: {
    fin: 'Suomi',
    swe: 'Ruotsi',
    eng: 'Englanti',
    fra: 'Ranska',
    deu: 'Saksa',
    dan: 'Tanska',
    nor: 'Norja',
    sme: 'Pohjoissaame',
    ita: 'Italia',
    spa: 'Espanja',
    rus: 'Venäjä',
    por: 'Portugali',
    isl: 'Islanti',
    ukr: 'Ukraina',
    und: '',
  },
  sv: {
    fin: 'Finska',
    swe: 'Svenska',
    eng: 'Engelska',
    fra: 'Franska',
    deu: 'Tyska',
    dan: 'Danska',
    nor: 'Norska',
    sme: 'Nordsamiska',
    ita: 'Italienska',
    spa: 'Spanska',
    rus: 'Ryska',
    por: 'Portugisiska',
    isl: 'Isländska',
    ukr: 'Ukrainska',
    und: '',
  },
};

export const legacyLanguageMap: LegacyLanguageCodeMap = {
  fih: 'fin',
  svh: 'swe',
  fi: 'fin',
  qfi: 'fin',
  sv: 'swe',
  qsw: 'swe',
  en: 'eng',
  fr: 'fra',
  de: 'deu',
  da: 'dan',
  no: 'nor',
  se: 'sme',
  it: 'ita',
  es: 'spa',
  ru: 'rus',
  pt: 'por',
  is: 'isl',
};

export const errorMessages: ErrorMessageMap = {
  [ErrorName.ERROR]: {
    sv: sv['errorMessages_error'],
    fi: fi['errorMessages_error'],
  },
  [ErrorName.NOT_FOUND_ERROR]: {
    sv: sv['errorMessages_NotFoundError'],
    fi: fi['errorMessages_NotFoundError'],
  },
  [ErrorName.ADD_FAVORITE_ERROR]: {
    sv: sv['errorMessages_AddFavoriteError'],
    fi: fi['errorMessages_AddFavoriteError'],
  },
  [ErrorName.REMOVE_FAVORITE_ERROR]: {
    sv: sv['errorMessages_RemoveFavoriteError'],
    fi: fi['errorMessages_RemoveFavoriteError'],
  },
  [ErrorName.AREENA_MEDIA_FETCH_ERROR]: {
    // Error message is shown to user in NoMediaOverlay
    sv: '',
    fi: '',
  },
  [ErrorName.LOGIN_API_ERROR_5XX]: {
    fi: fi['errorMessages_LoginApiError5xx'],
    sv: sv['errorMessages_LoginApiError5xx'],
  },
  [ErrorName.AUTH_ERROR]: {
    fi: fi['errorMessages_AuthError'],
    sv: sv['errorMessages_AuthError'],
  },
};
